import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { ContentContainer } from 'brand-guidelines/Layout-styled-components';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: center;

  /* Prevent tooltips from overflowing the right edge */
  overflow-x: clip;

  border-bottom: 1px solid ${BRAND_COLORS.stroke};
  background: ${BRAND_COLORS.white};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      height: auto;
    `,
  )}
`;

export const NavbarContent = styled(ContentContainer)`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(max-content, 1fr);

  column-gap: 10px;
  align-items: center;

  padding: 12px 0;

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      padding: 12px 16px;
    `,
  )}

  & > div {
    &:first-child {
      justify-self: start;
    }

    &:last-child {
      justify-self: end;
    }

    &:not(:first-child):not(:last-child) {
      justify-self: center;
    }
  }
`;

export const LogoWrapper = styled(Link)`
  flex-shrink: 0;
  width: fit-content;
`;
